import { render, staticRenderFns } from "./LawyersTable.vue?vue&type=template&id=0f0f4790&"
import script from "./LawyersTable.vue?vue&type=script&lang=js&"
export * from "./LawyersTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports